
import { jwtDecode } from 'jwt-decode';
import { User } from './types';

// JWT payload type definition
interface JwtPayload {
  /** Expiration time – seconds since epoch (standard JWT claim) */
  exp: number;
  /** Issue‑at time – seconds since epoch (optional) */
  iat?: number;
  /** Custom user claims that your backend embeds in the token */
  sub?: string;
  email?: string;
  username?: string;
  [key: string]: unknown;
}

/**
 * Decodes a JWT token into a payload object
 */
export const decodeJwt = (token: string): JwtPayload => jwtDecode<JwtPayload>(token);

/**
 * Checks if a token is expired
 */
export const isTokenExpired = (token: string): boolean => {
  try {
    const { exp } = decodeJwt(token);
    return Date.now() >= exp * 1000;
  } catch {
    // If decoding fails we treat the token as invalid / expired
    return true;
  }
};

/**
 * Extracts user information from a JWT token
 */
export const extractUserFromToken = (token: string): User | null => {
  try {
    const payload = decodeJwt(token);
    const { sub: id, email, username, name, ...rest } = payload;
    return { id: id ?? '', email, username, name, ...rest } as User;
  } catch {
    return null;
  }
};
